/**
 * Chevron Right Icon
 */

import type { IconProps } from '../../types';

export function ChevronRightIcon({ 
  className, 
  size = 24, 
  color = 'currentColor',
  'aria-label': ariaLabel = 'Next',
  ...props
}: IconProps) {
  return (
    <svg 
      className={className}
      width={size} 
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-label={ariaLabel}
      role="img"
      {...props}
    >
      <polyline points="9 18 15 12 9 6" />
    </svg>
  );
}

